module.exports = __webpack_public_path__ + "img/speedfriending.371e3d90.svg";